import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true }
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error(error, errorInfo)
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="panel panel-danger">
          <div className="panel-heading">Something went wrong on this page</div>
          <div className="panel-body">
            Please try again. if the problem persists contact support.
          </div>
        </div>
      )
    }

    return this.props.children; 
  }
}

export default ErrorBoundary